import { configureStore } from "@reduxjs/toolkit";
import counterReducer from "./counterSlice";

// 配置 Store
export const store = configureStore({
  reducer: {
    counter: counterReducer, // 注册计数器切片
    // 后续可添加其他切片，如 user: userReducer
  },
});
